// extracted by mini-css-extract-plugin
module.exports = {"main":"blog_main__1srDW","blogContainer":"blog_blogContainer__W9b61","separator":"blog_separator___b_pZ"};